export const UPLOADED_TEXT = "Did you upload all of your menu files? Press submit to confirm.";
export const DATE_OPTIONS = {"day": "2-digit", "hour": 'numeric', "minute": 'numeric', "timeZone": "Canada/Pacific", "month": "short"};
export const SUBMISSION_ERROR = "Unable to upload menu at this time. Please message us in the chatbox on the bottom right corner for now";
export const NOTHING_TO_SUBMIT = "You have not provided a link or file to submit";


// WEBPACK FOOTER //
// ./src/views/Update/constants.js